import type { Element } from 'hast';
import { MetricOption } from '../../interfaces/MetricsInterface';
import { METRIC_TAG_PREFIX, metricOptionValue, parseMetricTag } from '../../services/metricsService';

export const METRIC_TAG_LINE = new RegExp(
  `^[ \\t]*(?:\\[[^\\]]*\\]\\(${METRIC_TAG_PREFIX}[^)]*\\)[ \\t]*)+$\\n?`,
  'gm'
);

export const stripMetricTags = (text: string): string => text.replace(METRIC_TAG_LINE, '').replace(/\n{3,}/g, '\n\n');

export const metricsOfTagParagraph = (
  node: Element | undefined,
  metricOptions: MetricOption[]
): MetricOption[] | null => {
  const children = (node?.children ?? []).filter((child) => child.type !== 'text' || child.value.trim() !== '');
  if (children.length === 0) return null;

  const metrics: MetricOption[] = [];
  for (const child of children) {
    if (child.type !== 'element' || child.tagName !== 'a') return null;
    const { href } = child.properties;
    if (typeof href !== 'string') return null;
    const parsed = parseMetricTag(href);
    if (!parsed) return null;
    const option = metricOptions.find((entry) => entry.value === metricOptionValue(parsed.source, parsed.name));
    if (option && !metrics.some((entry) => entry.value === option.value)) metrics.push(option);
  }
  return metrics;
};
